import React, {Component} from 'react';
import ProposeProject from "./ProposeProject/ProposeProject";

class App extends Component {
    render() {
        return (
            <div>
                <ProposeProject/>
            </div>
        );
    }
}

export default App;